var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { PureComponent } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import intercom from "@irati/utils/intercom";
import { PartialRoute, IndexRedirect } from "@irati/utils/history/routing";
import { injectIntl } from "@irati/utils/lang";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import Loading from "@irati/ui/src/Loading";
import { hangPromise } from "@irati/utils/promise";
import OnboardingService from "@irati/onboarding/services/onboarding";
import OnboardingStep from "@irati/onboarding/enums/Step";
import { getTenant } from "@irati/identity/services/tenant";
import authentication from "@irati/auth";
import PerkboxTour from "@irati-web/tour";
import InviteAdmin from "../components/InviteAdmin";
import { getOrderedSectionSteps, getStepDetails, isValidStep, getFirstIncompleteStep, isPathActive, areAllStepsDone } from "../helpers";
import { StepContent, SideBar, GhostActions } from "../components";
import TenantOnboardingAppContainer from "../containers/TenantOnboarding";
import { FullWidth, FlexContainer } from "../components/styled";
import stepDetails, { SetupSections } from "../constants/stepConfig";
import tenantSetupTourSteps, { TENANT_SETUP_TOUR_PREFIX } from "../tour";
var LEGACY_TENANT_TOUR_COOKIE = "tenantSetupTourComplete";
var LEGACY_TOUR_COMPLETE_VALUE = "tourComplete";
var PartialRoutes = /** @class */ (function (_super) {
    __extends(PartialRoutes, _super);
    function PartialRoutes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            tourSteps: tenantSetupTourSteps,
            showTour: false
        };
        // if you navigate away from invite-admin path show the tour (as the footer will be there)
        _this.componentWillReceiveProps = function (nextProps) {
            var _a, _b, _c;
            if (((_a = nextProps.location) === null || _a === void 0 ? void 0 : _a.pathname) !== ((_b = _this.props.location) === null || _b === void 0 ? void 0 : _b.pathname)) {
                if (((_c = nextProps.location) === null || _c === void 0 ? void 0 : _c.pathname) !== "/setup-tenant/invite-admin") {
                    _this.shouldShowTour().then(function (showTour) { return _this.setState({ showTour: showTour }); });
                }
            }
        };
        _this.shouldShowTour = function () {
            if (authentication.isUserGhost()) {
                return Promise.resolve(false);
            }
            // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
            var showTourLegecyCheck = localStorage.getItem(LEGACY_TENANT_TOUR_COOKIE) === LEGACY_TOUR_COMPLETE_VALUE;
            return OnboardingService.get(authentication.user().uuid).then(function (res) {
                var showTour = !res.completedSteps.includes(OnboardingStep.HAS_COMPLETED_TENANT_SETUP_TOUR);
                // If the service thinks the user should see the tour but they have the LocalStorage value, fire an update
                if (showTour && showTourLegecyCheck) {
                    _this.neverShowTourAgain();
                    return false;
                }
                return showTour;
            });
        };
        _this.neverShowTourAgain = function () { return OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_COMPLETED_TENANT_SETUP_TOUR); };
        _this.componentWillUnmount = function () { return intercom.show(); };
        _this.getDefaultRoute = function (steps) {
            var _a = stepDetails[getFirstIncompleteStep(steps).stepId], nestedPath = _a.nestedPath, title = _a.title;
            return React.createElement(IndexRedirect, { match: _this.props.path, to: nestedPath, title: title });
        };
        _this.updateOnboardingSteps = function (steps) { return __awaiter(_this, void 0, void 0, function () {
            var tenantOnboarding;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tenantOnboarding = __assign({}, this.state.tenantOnboarding);
                        if (!areAllStepsDone(steps)) return [3 /*break*/, 2];
                        return [4 /*yield*/, OnboardingService.updateTenantOnboarding({ onboardingFinished: true })];
                    case 1:
                        _a.sent();
                        tenantOnboarding.onboardingFinished = true;
                        _a.label = 2;
                    case 2:
                        tenantOnboarding.assignedSteps = steps.filter(isValidStep);
                        this.setState({ tenantOnboarding: tenantOnboarding });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    PartialRoutes.prototype.componentDidMount = function () {
        var _this = this;
        var promises = [
            OnboardingService.getTenantOnboarding(),
            getTenant(authentication.userTenant().uuid),
            this.shouldShowTour()
        ];
        var updateAuthTenant = this.props.updateAuthTenant;
        var load = Promise.all(promises).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var tenantOnboarding, tenant, showTour, steps;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tenantOnboarding = res[0];
                        tenant = res[1];
                        showTour = res[2];
                        steps = tenantOnboarding.assignedSteps.filter(isValidStep);
                        tenantOnboarding.assignedSteps = steps;
                        if (!areAllStepsDone(steps)) return [3 /*break*/, 2];
                        return [4 /*yield*/, OnboardingService.updateTenantOnboarding({ onboardingFinished: true })];
                    case 1:
                        _a.sent();
                        tenantOnboarding.onboardingFinished = true;
                        _a.label = 2;
                    case 2: return [4 /*yield*/, updateAuthTenant(tenant)];
                    case 3:
                        _a.sent();
                        this.setState({ tenantOnboarding: tenantOnboarding, tenant: tenant });
                        // do not show tour on invite admin path as it has no footer
                        if (!isPathActive("invite-admin")) {
                            this.setState({ showTour: showTour });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        this.setState({ load: load });
    };
    PartialRoutes.prototype.render = function () {
        var _this = this;
        var _a = this.props, path = _a.path, formatMessage = _a.formatMessage;
        var _b = this.state, tenantOnboarding = _b.tenantOnboarding, load = _b.load, tourSteps = _b.tourSteps, showTour = _b.showTour;
        if (tenantOnboarding === null || tenantOnboarding === void 0 ? void 0 : tenantOnboarding.onboardingFinished) {
            return React.createElement(Redirect, { to: "/" });
        }
        return (React.createElement(TenantOnboardingAppContainer, null,
            React.createElement(Loading, { load: load },
                React.createElement(PerkboxTour, { tourPrefix: TENANT_SETUP_TOUR_PREFIX, run: showTour, onClose: this.neverShowTourAgain, onComplete: this.neverShowTourAgain, steps: tourSteps }),
                tenantOnboarding && (React.createElement(FlexContainer, null,
                    React.createElement(SideBar, { onboardingSteps: tenantOnboarding.assignedSteps, customiseSteps: getOrderedSectionSteps(tenantOnboarding.assignedSteps, SetupSections.CUSTOMISE), communicateSteps: getOrderedSectionSteps(tenantOnboarding.assignedSteps, SetupSections.COMMUNICATE), inviteSteps: getOrderedSectionSteps(tenantOnboarding.assignedSteps, SetupSections.INVITE) }),
                    React.createElement(FullWidth, null,
                        React.createElement(PartialRoute, { component: InviteAdmin, match: path, path: "/invite-admin", title: "invite-admin" }),
                        tenantOnboarding.assignedSteps.map(function (step) {
                            var _a = getStepDetails(step), title = _a.title, subTitle = _a.subTitle, nestedPath = _a.nestedPath, stepComponent = _a.stepComponent;
                            return (React.createElement(PartialRoute, { key: step.stepId, component: StepContent, componentProps: __assign({ updateOnboardingSteps: _this.updateOnboardingSteps, tenantOnboarding: tenantOnboarding, StepComponent: stepComponent, title: title,
                                    subTitle: subTitle }, step), match: path, path: nestedPath, title: formatMessage({ id: title }) }));
                        })),
                    this.getDefaultRoute(tenantOnboarding.assignedSteps)))),
            React.createElement(GhostActions, null)));
    };
    return PartialRoutes;
}(PureComponent));
var mapDispatchToProps = function (dispatch) {
    return {
        updateAuthTenant: function () { return dispatch(AuthActions.updateTenant()); }
    };
};
export default connect(null, mapDispatchToProps)(withRouter(injectIntl(PartialRoutes)));
